(() => {
  if (window.beadifiqueMobileMenuReady) return;
  window.beadifiqueMobileMenuReady = true;
  const mobile = matchMedia('(max-width: 1024px)');
  const root = () => document.querySelector('[data-beadifique-mobile-menu]');
  let opener = null;
  let restoreFocus = true;
  let activeTab = 'shop';
  let suppressTouchClickUntil = 0;
  const destinations = { shop: 'bm-shop-root', guides: 'bm-guides-root' };
  const history = new Map();
  const scrollPositions = new Map();
  const close = (restore = true) => {
    restoreFocus = restore;
    const dialog = root();
    if (dialog?.open) dialog.close();
    document.body.classList.remove('beadifique-menu-open');
    document.querySelectorAll('.mobileMenu-toggle').forEach(button => button.setAttribute('aria-expanded', 'false'));
  };
  const showPanel = (id, back = false) => {
    const dialog = root();
    const target = dialog?.querySelector('#' + CSS.escape(id));
    if (!target) return;
    const tabPanel = target.closest('[data-bm-tabpanel]');
    const scroll = dialog.querySelector('.bm-scroll');
    const previous = destinations[activeTab];
    scrollPositions.set(previous, scroll.scrollTop);
    if (!back) history.set(id, { previous, control: document.activeElement });
    tabPanel.querySelectorAll('[data-bm-pane]').forEach(panel => panel.hidden = panel !== target);
    destinations[activeTab] = id;
    scroll.scrollTop = back ? (scrollPositions.get(id) || 0) : 0;
    const returnControl = back ? history.get(previous)?.control : null;
    (returnControl?.isConnected ? returnControl : target.querySelector('h2')).focus({ preventScroll: true });
  };
  const showTab = key => {
    const dialog = root();
    activeTab = key;
    if (key === 'shop') {
      destinations.shop = 'bm-shop-root';
      dialog.querySelectorAll('[data-bm-tabpanel="shop"] [data-bm-pane]').forEach(panel => panel.hidden = panel.id !== 'bm-shop-root');
    }
    dialog.querySelectorAll('[data-bm-tab]').forEach(tab => {
      const active = tab.dataset.bmTab === key;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    dialog.querySelectorAll('[data-bm-tabpanel]').forEach(panel => panel.hidden = panel.dataset.bmTabpanel !== key);
    dialog.querySelector('.bm-scroll').scrollTop = 0;
  };
  const bind = () => {
    const dialog = root();
    if (!dialog || dialog.dataset.bound) return;
    dialog.dataset.bound = 'true';
    activeTab = 'shop';
    destinations.shop = 'bm-shop-root';
    destinations.guides = 'bm-guides-root';
    history.clear();
    scrollPositions.clear();
    let swipe = null;
    let settleTimer = null;
    const scroll = dialog.querySelector('.bm-scroll');
    const resetMotion = () => {
      clearTimeout(settleTimer);
      settleTimer = null;
      swipe = null;
      delete dialog.dataset.bmDragging;
      delete dialog.dataset.bmSettling;
      dialog.style.removeProperty('--bm-swipe-x');
    };
    const settle = shouldClose => {
      swipe = null;
      clearTimeout(settleTimer);
      delete dialog.dataset.bmDragging;
      dialog.dataset.bmSettling = shouldClose ? 'closing' : 'returning';
      // Flush the finger's current position before transitioning to the endpoint.
      const width = dialog.getBoundingClientRect().width;
      dialog.style.setProperty('--bm-swipe-x', shouldClose ? -width + 'px' : '0px');
      const finish = () => {
        if (shouldClose && dialog.open) close();
        resetMotion();
      };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else settleTimer = setTimeout(finish, 240);
    };
    const cancelSwipe = () => {
      if (swipe?.horizontal) {
        suppressTouchClickUntil = performance.now() + 400;
        settle(false);
      } else swipe = null;
    };
    dialog.addEventListener('touchstart', event => {
      if (dialog.dataset.bmSettling) return;
      cancelSwipe();
      if (dialog.dataset.bmSettling) return;
      if (!dialog.open || dialog.dataset.bmSwipeClose !== 'true' || event.touches.length !== 1) return;
      if (event.target.closest('input,textarea,select,[contenteditable],.bm-search') || window.getSelection()?.toString()) return;
      const touch = event.touches[0];
      const box = dialog.getBoundingClientRect();
      if (touch.clientX < box.left || touch.clientX > box.right) return;
      swipe = { id: touch.identifier, x: touch.clientX, y: touch.clientY, lastX: touch.clientX, lastMove: performance.now(), maxDistance: 0, time: performance.now(), scrollTop: scroll.scrollTop, width: box.width, horizontal: false };
    }, { passive: true });
    dialog.addEventListener('touchmove', event => {
      if (!swipe) return;
      const touch = [...event.touches].find(item => item.identifier === swipe.id);
      if (event.touches.length !== 1 || !touch) { cancelSwipe(); return; }
      const dx = touch.clientX - swipe.x;
      const dy = Math.abs(touch.clientY - swipe.y);
      if (Math.abs(scroll.scrollTop - swipe.scrollTop) > 12) { cancelSwipe(); return; }
      if (!swipe.horizontal) {
        if (dx <= -8 && -dx >= dy * 1.25) swipe.horizontal = true;
        else if (dx > 12 || (dy >= 8 && dy > Math.abs(dx))) { swipe = null; return; }
      }
      if (swipe.horizontal) {
        if (Math.abs(touch.clientX - swipe.lastX) >= 2) {
          swipe.lastMove = performance.now();
          swipe.lastX = touch.clientX;
        }
        swipe.maxDistance = Math.max(swipe.maxDistance, -dx);
        dialog.dataset.bmDragging = 'true';
        dialog.style.setProperty('--bm-swipe-x', Math.min(0, Math.max(-swipe.width, dx)) + 'px');
        if (event.cancelable) event.preventDefault();
      }
    }, { passive: false });
    dialog.addEventListener('touchend', event => {
      const start = swipe;
      swipe = null;
      if (!start) return;
      const touch = [...event.changedTouches].find(item => item.identifier === start.id);
      if (event.touches.length || !touch || window.getSelection()?.toString()) {
        if (start.horizontal) settle(false);
        return;
      }
      const distance = start.x - touch.clientX;
      const vertical = Math.abs(touch.clientY - start.y);
      const elapsed = Math.max(1, performance.now() - start.time);
      const deliberate = distance >= Math.min(96, Math.max(64, start.width * .2));
      const flick = distance >= 45 && distance / elapsed >= .5;
      const paused = Math.abs(touch.clientX - start.lastX) < 3 && performance.now() - start.lastMove > 350;
      const reversed = start.maxDistance - distance > 18;
      const committed = (deliberate || flick) && !paused && !reversed && vertical <= distance * .8 && Math.abs(scroll.scrollTop - start.scrollTop) <= 12;
      if (!start.horizontal && !committed) return;
      if (event.cancelable) event.preventDefault();
      suppressTouchClickUntil = performance.now() + 400;
      settle(committed);
    }, { passive: false });
    dialog.addEventListener('touchcancel', cancelSwipe, { passive: true });
    dialog.addEventListener('close', () => {
      resetMotion();
      document.body.classList.remove('beadifique-menu-open');
      document.querySelectorAll('.mobileMenu-toggle').forEach(button => button.setAttribute('aria-expanded', 'false'));
      if (restoreFocus && opener?.isConnected && mobile.matches) opener.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
        return;
      }
      const control = event.target.closest('button,a');
      if (!control) return;
      if (control.hasAttribute('data-bm-close')) close();
      else if (control.dataset.bmTab) showTab(control.dataset.bmTab);
      else if (control.dataset.bmGo) showPanel(control.dataset.bmGo);
      else if (control.dataset.bmBack) showPanel(control.dataset.bmBack, true);
      else if (control.hasAttribute('data-bm-hours')) {
        const hours = document.querySelector('#store-hours-location');
        if (hours && document.querySelector('#halo-store-hours-sidebar')) {
          event.preventDefault();
          close(false);
          hours.click();
        }
      }
    });
    dialog.addEventListener('keydown', event => {
      if (!event.target.matches('[data-bm-tab]')) return;
      const tabs = [...dialog.querySelectorAll('[data-bm-tab]')];
      const index = tabs.indexOf(event.target);
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      tabs[next].focus();
      showTab(tabs[next].dataset.bmTab);
    });
    document.querySelectorAll('.mobileMenu-toggle').forEach(button => {
      button.setAttribute('aria-controls', dialog.id);
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-expanded', 'false');
    });
  };
  document.addEventListener('click', event => {
    if (performance.now() < suppressTouchClickUntil && event.detail !== 0 && event.sourceCapabilities?.firesTouchEvents !== false) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const button = event.target.closest('.mobileMenu-toggle');
    const dialog = root();
    if (!button || !dialog || !mobile.matches || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    bind();
    showTab('shop');
    destinations.shop = 'bm-shop-root';
    destinations.guides = 'bm-guides-root';
    for (const [key, id] of Object.entries(destinations)) {
      dialog.querySelectorAll('[data-bm-tabpanel="' + key + '"] [data-bm-pane]').forEach(panel => panel.hidden = panel.id !== id);
    }
    history.clear();
    scrollPositions.clear();
    opener = button;
    restoreFocus = true;
    document.body.classList.remove('menu_open');
    dialog.showModal();
    dialog.querySelector('.bm-scroll').scrollTop = 0;
    document.body.classList.add('beadifique-menu-open');
    button.setAttribute('aria-expanded', 'true');
  }, true);
  mobile.addEventListener('change', event => { if (!event.matches) close(); });
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('[data-beadifique-mobile-menu]')) close();
  });
  window.addEventListener('pageshow', () => close());
  bind();
})();
